import { EmVatCorrections } from 'components/EmVatCorrections';
import { Page } from 'layouts/Page';

export const EmVatCorrectionsPage = () => {
	return (
		<Page title="EM VAT corrections – EAS Control Center">
			<EmVatCorrections />
		</Page>
	);
};
